<template>
  <div class="drawer" ref="drawer">
    <img :src="iconclose" class="icon-close mx-4 my-4" @click.prevent="CloseDrawer" />
    <div class="content-drawer">
      <div class="access-rapid">
        <div class="d-flex gap-1 align-items-center">
          <img :src="iconplus" class="icon-plus mx-3 my-4" /><label class="title">{{
            $t("drawer_sidebar.add_shortcut")
          }}</label>
        </div>
        <div
          v-if="showLimitMessage"
          class="limit-message mx-3 my-2"
          v-html="$sanitize.sanitizeI18nContent(limitMessage)"
        ></div>
        <div class="row cards mx-3">
          <div
            v-for="shortcut in firstThreeShortcuts"
            :key="shortcut.id"
            class="col-lg-4 col-md-4 col-sm-12 card mx-2"
            :class="{ 'card-selected': isShortcutSelected(shortcut.id) }"
            @click="toggleShortcut(shortcut.id)"
          >
            <img :src="getDynamicSvg(shortcut.icon, isShortcutSelected(shortcut.id))" width="60" height="60" />
            <label class="text-center">{{ shortcut.label }}</label>
          </div>
        </div>
        <div class="row cards mx-3">
          <div
            v-for="shortcut in remainingShortcuts.slice(0, 3)"
            :key="shortcut.id"
            class="col-lg-4 col-md-4 col-sm-12 card mx-2"
            :class="{
              'card-to-add': !isShortcutSelected(shortcut.id),
              'card-selected': isShortcutSelected(shortcut.id),
            }"
            @click="toggleShortcut(shortcut.id)"
          >
            <img :src="getDynamicSvg(shortcut.icon, isShortcutSelected(shortcut.id))" width="60" height="60" />
            <label class="text-center">{{ shortcut.label }}</label>
          </div>
        </div>
        <div class="row cards mx-3">
          <div
            v-for="shortcut in remainingShortcuts.slice(3)"
            :key="shortcut.id"
            class="col-lg-4 col-md-4 col-sm-12 card mx-2"
            :class="{
              'card-to-add': !isShortcutSelected(shortcut.id),
              'card-selected': isShortcutSelected(shortcut.id),
            }"
            @click="toggleShortcut(shortcut.id)"
          >
            <img :src="getDynamicSvg(shortcut.icon, isShortcutSelected(shortcut.id))" width="60" height="60" />
            <label class="text-center">{{ shortcut.label }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconclose from "../assets/close.svg";
  import iconplus from "../assets/plus.svg";
  import { useShortcutsStore } from "@/stores/shortcutsStore";
  import { SHORTCUTS_CONFIG } from "@/config/shortcuts";

  import mes_factures_blue from "../assets/mes_factures-blue.svg";
  import mes_commandes_blue from "../assets/mes_commandes-blue.svg";
  import mes_stats_blue from "../assets/mes_stats-blue.svg";
  import contact_blue from "../assets/contact-blue.svg";
  import documents_blue from "../assets/documents-blue.svg";
  import adresse_blue from "../assets/adresse-livraison-blue.svg";
  import calucl_ration_blue from "../assets/calucl-ration-blue.svg";
  import mes_factures_orange from "../assets/mes_factures-orange.svg";
  import mes_commandes_orange from "../assets/mes_commandes-orange.svg";
  import mes_stats_orange from "../assets/mes_stats-orange.svg";
  import contact_orange from "../assets/contact-orange.svg";
  import documents_orange from "../assets/documents-orange.svg";
  import adresse_orange from "../assets/adresse-livraison-orange.svg";
  import calucl_ration_orange from "../assets/calucl-ration-orange.svg";

  export default {
    data() {
      return {
        iconclose,
        iconplus,
        shortcutsStore: null,
        showLimitMessage: false,
      };
    },
    computed: {
      firstThreeShortcuts() {
        return SHORTCUTS_CONFIG.slice(0, 3);
      },
      limitMessage() {
        return this.$t("drawer_sidebar.limit_message");
      },
      remainingShortcuts() {
        return SHORTCUTS_CONFIG.slice(3);
      },
      emptySlots() {
        const remaining = this.remainingShortcuts.length;
        const slotsPerRow = 3;
        const emptyCount = slotsPerRow - (remaining % slotsPerRow);
        return emptyCount === slotsPerRow ? 0 : emptyCount;
      },
    },
    created() {
      this.shortcutsStore = useShortcutsStore();
    },
    beforeUnmount() {
      document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
      CloseDrawer() {
        this.$emit("close-drawer-raccourci");
      },
      handleClickOutside(event) {
        const drawer = this.$refs.drawer;
        if (drawer && !drawer.contains(event.target)) {
          this.CloseDrawer();
        }
      },
      getDynamicSvg(iconName, isSelected) {
        const iconMaps = {
          blue: {
            "mes_factures.svg": mes_factures_blue,
            "mes_commandes.svg": mes_commandes_blue,
            "mes_stats.svg": mes_stats_blue,
            "contact.svg": contact_blue,
            "documents.svg": documents_blue,
            "adresse-livraison.svg": adresse_blue,
            "calucl-ration.svg": calucl_ration_blue,
          },
          orange: {
            "mes_factures.svg": mes_factures_orange,
            "mes_commandes.svg": mes_commandes_orange,
            "mes_stats.svg": mes_stats_orange,
            "contact.svg": contact_orange,
            "documents.svg": documents_orange,
            "adresse-livraison.svg": adresse_orange,
            "calucl-ration.svg": calucl_ration_orange,
          },
        };

        const selectedMap = isSelected ? iconMaps.blue : iconMaps.orange;
        return selectedMap[iconName] || "";
      },
      isShortcutSelected(shortcutId) {
        if (!this.shortcutsStore) return false;
        return this.shortcutsStore.isShortcutSelected(shortcutId);
      },
      async toggleShortcut(shortcutId) {
        if (!this.shortcutsStore) return;
        const isSelected = this.isShortcutSelected(shortcutId);
        if (!isSelected && !this.shortcutsStore.canSelectMore) {
          this.showLimitMessage = true;
          setTimeout(() => {
            this.showLimitMessage = false;
          }, 3000);
          return;
        }
        await this.shortcutsStore.toggleShortcut(shortcutId);
      },
    },
  };
</script>
<style scoped>
  .drawer {
    position: fixed;
    z-index: 9999999;
    top: 0;
    right: 0;
    width: 650px;
    height: 100%;
    background-color: #fff;
    box-shadow: -2px 0px 10px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease-in-out;
  }

  .icon-close {
    float: right;
    cursor: pointer;
  }
  .content-drawer {
    position: relative;
    top: 15%;
    label.title {
      color: #1f327d;
      font-size: 26px;
      font-weight: bold;
    }
    .cards {
      margin-top: 4rem;
    }
    .access-rapid .card {
      color: #1e347d;
      font-size: 16px;
      font-weight: bold;
      position: relative;
      background: #f5f6f9;
      border: 1px solid #e1e4ed;
      border-radius: 10px;
      cursor: pointer;
      height: 100px;
      width: 150px;
      img {
        position: absolute;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 0;
        width: 60px;
        height: 60px;
      }
      label {
        position: relative;
        top: 15px;
        display: block;
        line-height: 20px;
      }
    }
    .access-rapid .card-to-add {
      background: #e1e4ed !important;
    }

    .access-rapid .card-selected label {
      color: #1e347d !important;
    }
    .limit-message {
      background-color: #ffe0b2;
      color: #e65100;
      padding: 10px 15px;
      border-radius: 5px;
      text-align: center;
      margin: 15px auto;
      font-size: 14px;
      font-weight: 600;
      max-width: 90%;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }
</style>
